// React and related imports
import React from 'react';

// Flowbite components
import { Table } from 'flowbite-react';

// Custom components
import { TableHead } from '../../components/Table/Table';
import { AnswerTableBody } from './AnswerTableBody';

// i18 translations
import { useTranslation } from 'react-i18next';

// Interfaces
import { IAnswer } from '../../common/interfaces/Answer.interface';

interface AnswerTableProps {
  answersList: IAnswer[];
  handleEditAnswer: (answer: IAnswer) => void;
}

export const AnswerTable: React.FC<AnswerTableProps> = ({
  answersList,
  handleEditAnswer,
}) => {
  const { t } = useTranslation();

  const columnHeadLabels = [
    { id: 'options', label: t('answers.options') },
    { id: 'correctAnswer', label: t('answers.correctAnswer') },
    { id: 'actions', label: '' },
  ];

  return (
    <Table>
      <TableHead columns={columnHeadLabels} withSortingIcon />
      <AnswerTableBody
        answersList={answersList}
        handleEditAnswer={handleEditAnswer}
      />
    </Table>
  );
};
